import {
  Button,
  Card,
  Divider,
  Grid,
  Snackbar,
  Typography,
  Alert as MuiAlert,
  Pagination,
  CardContent,
  Avatar,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField
} from '@mui/material'

import {
  Add as AddIcon,
  Phone,
  Close,
  Search as SearchIcon
} from '@mui/icons-material'
import { useEffect, useState, forwardRef, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { businessCheck } from '../../utils/utils'
import ContactPersonDrawer from '../contact_person/contactperson/contactPersonDialog'
import CustomerDrawer from '../customer/customer/customerDialog'
import CustomerInfoDrawer from '../customer/customer/customerInfoDialog'
import _ from 'lodash'
import MainCard, {
  ConfirmationDialog,
  ErrorScreen,
  Search,
  SearchIconWrapper,
  ShowNoRecordsFound,
  SnackBarHideDuration,
  SnackBarTransition,
  StyledInputBase,
  StyledTableCell,
  StyledTableRow,
  stringAvatar
} from '../../utils/ui_utils'
import UserTypeShimmer from '../../utils/ui_components/shimmers/userTypeShimmer'
import {
  useCheckCustomerExists,
  useCreateCustomer,
  useCreateDefaultCustomer,
  useFetchCustomer,
  useFetchDefaultCustomer,
  useSearchCustomer,
  useUpdateCustomer
} from '../../modules/customer/customerHooks'
import {
  useCreateContactPerson,
  useSearchContactPerson
} from '../../modules/contactPerson/contactPersonHooks'
import { useCreateLedger } from '../../modules/ledger/ledgerHooks'

function Customer() {
  const jumpToInputRef = useRef(null)
  const searchInputRef = useRef(null)
  const [searchAutoFocus, setSearchAutoFocus] = useState(false)
  const [jumpAutoFocus, setJumpAutoFocus] = useState(false)
  const [shouldScrollToTop, setShouldScrollToTop] = useState(false)
  const [page, setPage] = useState(1)
  const [contactPersonVisibility, setContactPersonVisibility] = useState(false)
  const [values, setValues] = useState()
  const [limit, setLimit] = useState(15)
  const [pagecount, setPageCount] = useState(0)
  const [goToPageInput, setGoToPageInput] = useState('')
  const [customerData, setCustomerData] = useState(null)
  const [showPopDialog, setShowPopDialog] = useState(false)
  const [snackbar, setSnackBar] = useState(false)
  const [PopUpMessage, setPopUpMessage] = useState(null)
  const [severity, setSeverity] = useState(null)
  const [deleteConfirmationVisibility, setDeleteConfirmationVisibility] =
    useState(false)
  const [customerDatas, setCustomerDatas] = useState([])
  const [contactPersonInitialData, setContactPersonInitialData] = useState({
    first_name: '',
    last_name: '',
    mobile: '',
    email: '',
    telephone: '',
    comments: ''
  })
  const [contactPersonDrawerVisibility, setContactPersonDrawerVisibility] =
    useState(false)
  const [customerDrawerMode, setCustomerDrawerMode] = useState('new')
  const [customerDrawerVisibility, setCustomerDrawerVisibility] =
    useState(false)
  const [customerInfoDrawerVisibility, setCustomerInfoDrawerVisibility] =
    useState(false)
  const [isSearchMode, setIsSearchMode] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const [enterPressed, setEnterPressed] = useState(true)
  const { searchContactPersonData } = useSearchContactPerson()
  const { createContactPerson } = useCreateContactPerson()
  const {
    fetchDefaultCustomerData,
    fetchDefaultCustomerHook,
    fetchDefaultCustomerError,
    fetchDefaultCustomerLoading
  } = useFetchDefaultCustomer()
  const { createDefaultCustomerHook } = useCreateDefaultCustomer()
  const { createCustomer: createCustomerHook } = useCreateCustomer()
  const { updateCustomer } = useUpdateCustomer()
  const {
    fetchCustomer,
    fetchCustomerData,
    fetchCustomerError,
    fetchCustomerLoading
  } = useFetchCustomer()
  const {
    searchCustomer,
    searchCustomerData,
    searchCustomerError,
    searchCustomerLoading
  } = useSearchCustomer()
  const { createLedger } = useCreateLedger()

  const handleSnackbarClose = () => {
    setSnackBar(false)
  }

  const toastMessage = (message, severity) => {
    setPopUpMessage(message)
    setSeverity(severity)
    setSnackBar(true)
  }

  const { checkCustomerExist } = useCheckCustomerExists()

  const createCustomer = async (ledgerCreate) => {
    let contact = []
    for (let i = 0; i < values.contactperson.length; i++) {
      if (values.contactperson[i]?.business_id) {
        delete values.contactperson[i].business_id
      }
      contact.push(BigInt(values.contactperson[i]?._id))
    }
    if (values?.gstn === '' || null) {
      delete values.gstn
    }
    if (values?.email === '' || null) {
      delete values.email
    }
    if (values?.address === '' || null) {
      delete values.address
    }
    if (values?.city === '' || null) {
      delete values.city
    }
    if (values?.state === '' || null) {
      delete values.state
    }
    if (values?.pincode === '' || null) {
      delete values.pincode
    }
    if (values?.country === '' || null) {
      delete values.country
    }

    delete values.contactperson
    values.contactperson = contact

    await createCustomerHook(values, (success, error, res) => {
      if (error) {
        setCustomerDrawerVisibility(true)
        toastMessage('Error Occurred', 'error')
      } else {
        let body = {
          name: values?.name,
          reference_id: res,
          type: 'Customer'
        }
        if (ledgerCreate) {
          createLedger(body, (success, error, res) => {
            if (error) {
              toastMessage('Error Occurred', 'error')
            } else {
              toastMessage('Ledger created successfully ', 'success')
              setCustomerDrawerVisibility(false)
              let payload = {
                pageNumber: page,
                limit: limit
              }
              fetchCustomer(payload)
            }
          })
        } else {
          setCustomerDrawerVisibility(false)
          let payload = {
            pageNumber: page,
            limit: limit
          }
          fetchCustomer(payload)
        }
        toastMessage('Customer created successfully ', 'success')
      }
    })
  }
  const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
  })

  const handlePageChange = async (event, value) => {
    setPage(value)
    if (isSearchMode) {
      let payload = {
        pageNumber: value,
        limit: limit,
        searchQuery: searchValue
      }
      await searchCustomer(payload)
    } else {
      let payload = {
        pageNumber: value,
        limit: limit
      }
      await fetchCustomer(payload)
    }
  }

  const handleGoToPageChange = (event) => {
    const value = event.target.value
    if (/^\d+$/.test(value) || value === '') {
      setGoToPageInput(value)
    }
  }

  const handleGoToPageSubmit = () => {
    const pageNum = parseInt(goToPageInput, 10)
    if (pageNum >= 1 && pageNum <= pagecount) {
      handlePageChange(null, pageNum)
      setGoToPageInput('')
      // Trigger scroll to top
      setShouldScrollToTop(true)
    }
  }

  const handleGoToPageKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleGoToPageSubmit()
    }
  }

  const pageCount = (data1) => {
    let count = Math.ceil(data1 / limit)
    setPageCount(count)
  }

  const history = useNavigate()
  useEffect(() => {
    pageLoad()
  }, [])

  useEffect(() => {
    if (fetchCustomerData.data?.length > 0) {
      setCustomerDatas(fetchCustomerData.data)
      pageCount(fetchCustomerData.total)
      // Scroll to top if triggered by Go button
      if (shouldScrollToTop) {
        window.scrollTo({ top: 0, behavior: 'smooth' })
        setShouldScrollToTop(false)
        setJumpAutoFocus(false)
        setSearchAutoFocus(true)
        setTimeout(() => {
          if (searchInputRef.current) {
            searchInputRef.current.focus()
          }
        }, 500)
      }
    } else {
      setCustomerDatas([])
      setPageCount(0)
    }
  }, [fetchCustomerData])

  useEffect(() => {
    if (searchCustomerData.data?.length > 0) {
      setCustomerDatas(searchCustomerData?.data)
      pageCount(searchCustomerData.total)
      // Scroll to top if triggered by Go button
      if (shouldScrollToTop) {
        window.scrollTo({ top: 0, behavior: 'smooth' })
        setShouldScrollToTop(false)
        setJumpAutoFocus(false)
        setSearchAutoFocus(true)
        setTimeout(() => {
          if (searchInputRef.current) {
            searchInputRef.current.focus()
          }
        }, 500)
      }
    } else {
      setCustomerDatas([]) // Set to empty array instead of 0
      setPageCount(0)
    }
  }, [searchCustomerData])

  const handlePopDialogButtonClicked = (createLedger) => {
    setShowPopDialog(false)
    createCustomer(createLedger)
  }

  const handleKeyDown = (event) => {
    {
      if (event.key === 'Enter') {
        setEnterPressed(true)
        if (event.target.value) {
          setPage(1)
          setIsSearchMode(true)
          let payload = {
            pageNumber: 1,
            limit: limit,
            searchQuery: event.target.value
          }
          searchCustomer(payload)
        }
      }
    }
  }

  const handleChange = (event) => {
    setSearchValue(event.target.value)
    setEnterPressed(false)
    if (event.target.value == '') {
      setPage(1)
      setIsSearchMode(false)
      setEnterPressed(false)
      let payload = {
        pageNumber: 1,
        limit: limit
      }
      fetchCustomer(payload)
    }
  }

  // useEffect(() => {
  //   if (!searchValue && isSearchMode) {
  //     setPage(1)
  //     setIsSearchMode(false)
  //     setEnterPressed(false)
  //     customerAPI.fetch.api(1, limit)
  //   } else if (enterPressed == false && searchValue !== '') {
  //     const delayDebounceFn = setTimeout(() => {
  //       setPage(1)
  //       setIsSearchMode(true)
  //       customerAPI.search.api(1, limit, searchValue)
  //     }, 3000)
  //     return () => clearTimeout(delayDebounceFn)
  //   }
  // }, [searchValue])

  const pageLoad = () => {
    businessCheck(history)
    let payload = {
      pageNumber: page,
      limit: limit
    }
    fetchCustomer(payload)
    fetchDefaultCustomerHook()
  }

  const CustomerListUI = ({ customer }) => (
    <MainCard
      sx={{
        mt: 1,
        p: 2,
        alignItems: 'center',
        transition: 'box-shadow 0.3s ease',
        borderRadius: 1,
        '&:hover': {
          boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.2)',
          backgroundColor: 'rgba(0, 0, 0, 0.04)'
        }
      }}
    >
      <Grid container column={6} spacing={1}>
        <Grid item>
          <Avatar {...stringAvatar(customer?.name)} />
        </Grid>
        <Grid item xs md>
          <Grid
            container
            direction="column"
            sx={{
              pl: 1,
              cursor: 'pointer'
            }}
            onClick={() => {
              if (
                fetchDefaultCustomerData?._id === customer?._id &&
                customer.ledger != undefined
              )
                return
              setCustomerDrawerVisibility(true)
              setCustomerDrawerMode('edit')
              setCustomerData(customer)
            }}
          >
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
              {customer?.name}
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.secondary' }}>
              <Phone
                color="success"
                sx={{ verticalAlign: 'middle', mr: 0.5, fontSize: 'medium' }}
              />{' '}
              {customer?.mobile}
            </Typography>
          </Grid>
        </Grid>
        {/* {(defaultCustomer?._id != customer?._id) && <Grid item textAlign="right">
          <IconButton
            size="small"
            color="error"
            component="span"
            onClick={() => {
              setCustomerData(customer)
              setDeleteConfirmationVisibility(true)
            }}
          >
            <Delete fontSize="small" />
          </IconButton>
        </Grid>} */}
      </Grid>
    </MainCard>
  )

  return (
    <>
      <Helmet title="Customer" />
      <Dialog
        maxWidth="xs"
        fullWidth
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        open={showPopDialog}
        onClose={() => setShowPopDialog(false)}
      >
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>
          <Typography gutterBottom>
            Do you want to create a ledger for this customer?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            color="success"
            variant="outlined"
            size="small"
            onClick={() => handlePopDialogButtonClicked(true)}
          >
            Yes
          </Button>

          <Button
            color="primary"
            variant="outlined"
            size="small"
            onClick={() => handlePopDialogButtonClicked(false)}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
      <Grid
        container
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Grid item xs={9} md={6}>
          <Typography variant="h4" gutterBottom display="inline">
            Customers
          </Typography>
        </Grid>
        <Grid item>
          {!fetchCustomerError &&
            Object.keys(fetchDefaultCustomerData)?.length > 0 && (
              <Button
                startIcon={<AddIcon />}
                variant="contained"
                size="small"
                color="primary"
                onClick={() => {
                  setCustomerDrawerVisibility(true)
                  setCustomerDrawerMode('new')
                  setCustomerData({
                    name: '',
                    mobile: '',
                    email: '',
                    gstn: '',
                    city: '',
                    pincode: '',
                    state: '',
                    country: '',
                    contactperson: []
                  })
                }}
              >
                Add Customer
              </Button>
            )}
          <CustomerDrawer
            visible={customerDrawerVisibility}
            title={
              customerDrawerMode == 'new'
                ? 'Create New Customer'
                : 'Edit Customer'
            }
            okText={customerDrawerMode == 'new' ? 'Create' : 'Update'}
            contactPersonData={searchContactPersonData?.data}
            initialValues={customerData}
            dialogMode={customerDrawerMode}
            contactPersonVisibility={contactPersonVisibility}
            isLedgerPresent={customerData?.ledger != undefined ? true : false}
            createLedgerClick={async () => {
              let data = {
                name: customerData.name,
                reference_id: customerData._id,
                type: 'Customer'
              }
              await createLedger(data, (success, error) => {
                if (error) {
                  toastMessage('Ledger Creation Failed', 'error')
                } else {
                  toastMessage('Ledger Created Successfully', 'success')
                  let payload = {
                    pageNumber: page,
                    limit: limit
                  }
                  fetchCustomer(payload)
                  setCustomerDrawerVisibility(false)
                }
              })
            }}
            onContactPersonSearch={(value) => {
              if (value != '') searchCustomer(value)
            }}
            onCancel={() => {
              setCustomerDrawerVisibility(false)
            }}
            onSubmit={(value) => {
              let values = _.cloneDeep(value)
              if (customerDrawerMode == 'new') {
                setValues(values)
                setShowPopDialog(true)
              } else {
                values.id = BigInt(values._id)
                delete values._id
                delete values.business_id
                delete values.ledger
                let contact = []
                if (values.contactperson) {
                  for (let i = 0; i < values.contactperson.length; i++) {
                    if (values.contactperson[i]?.business_id) {
                      delete values.contactperson[i].business_id
                    }
                    contact.push(BigInt(values.contactperson[i]?._id))
                  }
                } else {
                  delete values.contactperson
                  values.contactperson = contact
                }
                delete values.key
                updateCustomer(values, (success, error) => {
                  if (error) {
                    setCustomerDrawerVisibility(true)
                    toastMessage('Error Occurred', 'error')
                  } else {
                    setCustomerDrawerVisibility(false)
                    let payload = {
                      pageNumber: page,
                      limit: limit
                    }
                    fetchCustomer(payload)
                    toastMessage('Customer updated successfully ', 'success')
                  }
                })
              }
            }}
            onAddContactPersonClick={() => {
              setContactPersonDrawerVisibility(true)
            }}
            verifyMobile={(mobile) => {
              checkCustomerExist(mobile)
            }}
          />
        </Grid>
      </Grid>
      <Divider sx={{ marginTop: 5 }} />
      {(fetchCustomerLoading || searchCustomerLoading) && (
        <UserTypeShimmer shimmerCount={[1, 3, 5]} />
      )}
      {fetchCustomerError ? (
        <ErrorScreen onClick={pageLoad} />
      ) : (
        !fetchCustomerLoading &&
        !searchCustomerLoading &&
        Object.keys(fetchDefaultCustomerData)?.length <= 0 &&
        !customerDatas && (
          <Grid container spacing={5} sx={{ paddingTop: 5 }}>
            <Grid item xs sm md>
              <Box sx={{ margin: 2 }}>
                <Card raised sx={{ borderRadius: 3 }}>
                  <CardContent>
                    <Grid
                      container
                      alignItems="center"
                      justifyContent="center"
                      columns={6}
                      rowSpacing={3}
                      columnSpacing={3}
                    >
                      <Grid item>
                        <Typography variant="h6" gutterBottom display="inline">
                          No Default Customer Found
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Button
                          onClick={() => {
                            let data = {
                              name: 'Default Customer',
                              mobile: '1234567890'
                            }
                            createCustomerHook(data, (success, error, res) => {
                              if (error) {
                                toastMessage(
                                  'Default Customer Creation Failed',
                                  'error'
                                )
                              } else {
                                let defaultCustomer = { customer_id: res }
                                createDefaultCustomerHook(
                                  defaultCustomer,
                                  (success, error) => {
                                    if (error) {
                                      toastMessage(
                                        'Default Customer Creation Failed',
                                        'error'
                                      )
                                    } else {
                                      toastMessage(
                                        'Default Customer Created Successfully',
                                        'success'
                                      )
                                      let data1 = {
                                        name: 'Default Customer',
                                        reference_id: res,
                                        type: 'Customer'
                                      }
                                      createLedger(data1, (success, error) => {
                                        if (error) {
                                          toastMessage(
                                            'Ledger Creation Failed',
                                            'error'
                                          )
                                        } else {
                                          toastMessage(
                                            'Ledger Created Successfully',
                                            'success'
                                          )
                                        }
                                        fetchDefaultCustomerHook()
                                        let payload = {
                                          pageNumber: page,
                                          limit: limit
                                        }
                                        fetchCustomer(payload)
                                      })
                                    }
                                  }
                                )
                              }
                            })
                          }}
                        >
                          Click here to create Default Customer.
                        </Button>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Box>
            </Grid>
          </Grid>
        )
      )}
      {fetchCustomerError ? (
        <ErrorScreen onClick={pageLoad} />
      ) : (
        !fetchDefaultCustomerLoading &&
        !fetchCustomerLoading &&
        !searchCustomerLoading &&
        Object.keys(fetchDefaultCustomerData).length > 0 && (
          <Grid container spacing={5} sx={{ paddingTop: 5 }}>
            <Grid item xs sm md>
              <Box sx={{ margin: 2 }}>
                <Card raised sx={{ borderRadius: 3 }}>
                  <CardContent>
                    <MainCard sx={{ width: 300 }}>
                      <Search>
                        <SearchIconWrapper>
                          <SearchIcon />
                        </SearchIconWrapper>
                        <StyledInputBase
                          inputRef={searchInputRef}
                          fullWidth
                          placeholder="Search Customer by Name or Mobile"
                          inputProps={{
                            'aria-label': 'search'
                          }}
                          autoFocus={searchAutoFocus}
                          value={searchValue}
                          onFocus={(e) => {
                            setSearchAutoFocus(true)
                            setJumpAutoFocus(false)
                            const scrollPos = window.pageYOffset
                            requestAnimationFrame(() => {
                              window.scrollTo(0, scrollPos)
                            })
                          }}
                          onKeyDown={(e) => {
                            const scrollPos = window.pageYOffset
                            e.stopPropagation()
                            handleKeyDown(e)
                            requestAnimationFrame(() => {
                              window.scrollTo(0, scrollPos)
                            })
                          }}
                          onChange={(e) => {
                            const scrollPos = window.pageYOffset
                            e.stopPropagation()
                            handleChange(e)
                            window.scrollTo(0, scrollPos)
                          }}
                          onInput={(e) => {
                            const scrollPos = window.pageYOffset
                            requestAnimationFrame(() => {
                              window.scrollTo(0, scrollPos)
                            })
                          }}
                        />
                      </Search>
                    </MainCard>
                    {isSearchMode &&
                    customerDatas &&
                    customerDatas.length === 0 ? (
                      <Grid
                        container
                        spacing={0}
                        direction="column"
                        alignItems="center"
                        justifyContent="center"
                        sx={{ minHeight: '30vh', pt: 5 }}
                      >
                        <Grid item xs={12}>
                          <Typography variant="h6" gutterBottom align="center">
                            No Records Found
                          </Typography>
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            align="center"
                          >
                            No customers match your search criteria
                          </Typography>
                        </Grid>
                      </Grid>
                    ) : (
                      <Grid
                        sx={{ mt: 1 }}
                        container
                        columns={6}
                        rowSpacing={3}
                        columnSpacing={3}
                      >
                        {customerDatas?.map((row, index) => (
                          <Grid item xs={6} sm={3} md={2} key={index}>
                            <CustomerListUI customer={row} />
                          </Grid>
                        ))}
                      </Grid>
                    )}
                  </CardContent>
                  {pagecount > 1 && (
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                        p: 2,
                        backgroundColor: 'grey.50',
                        borderRadius: 1
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          width: '100%'
                        }}
                      >
                        <Pagination
                          count={pagecount}
                          page={page}
                          color="secondary"
                          size="small"
                          boundaryCount={2}
                          siblingCount={0}
                          showFirstButton
                          showLastButton
                          onChange={handlePageChange}
                          sx={{
                            '& .MuiPaginationItem-root': {
                              transition: 'all 0.2s ease-in-out'
                            }
                          }}
                        />
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          gap: 1.5,
                          backgroundColor: 'white',
                          p: 2,
                          borderRadius: 1,
                          boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                          transition: 'box-shadow 0.2s ease-in-out',
                          '&:hover': {
                            boxShadow: '0 2px 6px rgba(0,0,0,0.12)'
                          }
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{ color: 'text.secondary', fontWeight: 500 }}
                        >
                          Jump to
                        </Typography>
                        <TextField
                          inputRef={jumpToInputRef}
                          size="small"
                          autoFocus={jumpAutoFocus}
                          value={goToPageInput}
                          onFocus={(e) => {
                            setJumpAutoFocus(true)
                            setSearchAutoFocus(false)
                            const scrollPos = window.pageYOffset
                            requestAnimationFrame(() => {
                              window.scrollTo(0, scrollPos)
                            })
                          }}
                          onChange={(e) => {
                            const scrollPos = window.pageYOffset
                            e.stopPropagation()
                            handleGoToPageChange(e)
                            window.scrollTo(0, scrollPos)
                          }}
                          onKeyPress={(e) => {
                            const scrollPos = window.pageYOffset
                            e.stopPropagation()
                            handleGoToPageKeyPress(e)
                            window.scrollTo(0, scrollPos)
                          }}
                          placeholder="Page"
                          onKeyDown={(e) => {
                            const scrollPos = window.pageYOffset
                            e.stopPropagation()
                            if (
                              [
                                'ArrowUp',
                                'ArrowDown',
                                'PageUp',
                                'PageDown',
                                'Home',
                                'End'
                              ].includes(e.key)
                            ) {
                              e.preventDefault()
                            }
                            requestAnimationFrame(() => {
                              window.scrollTo(0, scrollPos)
                            })
                          }}
                          onInput={(e) => {
                            const scrollPos = window.pageYOffset
                            requestAnimationFrame(() => {
                              window.scrollTo(0, scrollPos)
                            })
                          }}
                          inputProps={{
                            style: { textAlign: 'center' }
                          }}
                          sx={{
                            width: '80px',
                            '& .MuiOutlinedInput-root': {
                              backgroundColor: 'white',
                              transition: 'all 0.2s ease-in-out',
                              '& fieldset': {
                                borderColor: 'grey.300',
                                borderWidth: '1px'
                              },
                              '&:hover fieldset': {
                                borderColor: 'secondary.main',
                                borderWidth: '1.5px'
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: 'secondary.main',
                                borderWidth: '2px',
                                boxShadow: '0 0 0 3px rgba(156, 39, 176, 0.1)'
                              }
                            },
                            '& .MuiOutlinedInput-input': {
                              textAlign: 'center',
                              fontWeight: 500,
                              padding: '7px 8px',
                              height: '20px',
                              lineHeight: '20px'
                            }
                          }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: 'text.secondary', fontWeight: 400 }}
                        >
                          of {pagecount}
                        </Typography>
                        <Button
                          variant="contained"
                          color="secondary"
                          size="small"
                          onClick={(e) => {
                            e.preventDefault()
                            handleGoToPageSubmit()
                          }}
                          onMouseDown={(e) => e.preventDefault()}
                          disableFocusRipple
                          disabled={
                            !goToPageInput ||
                            parseInt(goToPageInput, 10) < 1 ||
                            parseInt(goToPageInput, 10) > pagecount
                          }
                          sx={{
                            textTransform: 'none',
                            fontWeight: 500,
                            px: 2,
                            py: 0.75,
                            height: '34px',
                            lineHeight: 1,
                            transition: 'all 0.2s ease-in-out',
                            '&:hover': {
                              transform: 'translateY(-1px)',
                              boxShadow: '0 4px 8px rgba(156, 39, 176, 0.3)'
                            },
                            '&:active': {
                              transform: 'translateY(0)'
                            }
                          }}
                        >
                          Go
                        </Button>
                      </Box>
                    </Box>
                  )}
                </Card>
              </Box>
            </Grid>
          </Grid>
        )
      )}

      <CustomerInfoDrawer
        visible={customerInfoDrawerVisibility}
        title={'Customer Info'}
        cancelText={'Close'}
        onCancel={() => setCustomerInfoDrawerVisibility(false)}
        initialValues={customerData}
      />
      <ContactPersonDrawer
        initialValues={contactPersonInitialData}
        visible={contactPersonDrawerVisibility}
        title="Create Contact Person"
        okText={'Create'}
        onClose={() => setContactPersonDrawerVisibility(false)}
        onSubmit={(values) => {
          createContactPerson(values, (success, error) => {
            if (error) {
              setContactPersonDrawerVisibility(true)
              toastMessage('Error occured.', 'error')
            } else {
              setContactPersonDrawerVisibility(false)
              toastMessage('Contact Person created.', 'success')
            }
          })
        }}
      />

      <ConfirmationDialog
        visibility={deleteConfirmationVisibility}
        title={'Delete Customer Details'}
        message={`Do you want to delete details of Customer - ${customerDatas?.name} ?`}
        okText="Delete"
        cancelText={'Cancel'}
        onCancel={() => {
          setDeleteConfirmationVisibility(false)
        }}
        onOk={() => {
          let values = _.cloneDeep(customerData)
          values.id = values._id
          delete values._id
          delete values.business_id
          delete values.ledger
          let contact = []
          for (let i = 0; i < values.contactperson.length; i++) {
            if (values.contactperson[i]?.business_id) {
              delete values.contactperson[i].business_id
            }
            contact.push(BigInt(values.contactperson[i]?._id))
          }
          delete values.contactperson
          values.contactperson = contact
          values.delete_status = true
          delete values.key
          updateCustomer(values, (success, error) => {
            if (error) {
              toastMessage('Unable to delete Customer details', 'error')
            } else {
              let payload = {
                pageNumber: 1,
                limit: limit
              }
              fetchCustomer(payload)
              setPage(1)
              toastMessage('Customer details deleted successfully', 'success')
              setDeleteConfirmationVisibility(false)
            }
          })
        }}
      />
      <div>
        <Snackbar
          open={snackbar}
          autoHideDuration={SnackBarHideDuration}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          onClose={handleSnackbarClose}
          TransitionComponent={SnackBarTransition}
        >
          <Alert onClose={handleSnackbarClose} severity={severity}>
            {PopUpMessage}
          </Alert>
        </Snackbar>
      </div>
    </>
  )
}

export default Customer
